<div class="scv2-section">
  <div class="scv2-section-head scv2-no-print">
    <h2 class="scv2-h2">Shipping labels</h2>
    <p class="scv2-sub">Buy and print labels, or add manual tracking — mirrors Orders → Shipping labels in Shopify.</p>
  </div>

  <div *ngIf="!anyCarrier" class="scv2-warn scv2-no-print">
    <i class="pi pi-exclamation-circle"></i>
    <p>Connect a carrier to start buying labels.</p>
  </div>

  <div class="scv2-stat-grid scv2-no-print">
    <button type="button" class="scv2-stat-card" [class.scv2-active]="filter === 'unfulfilled'" (click)="setStatFilter('unfulfilled')">
      <div class="scv2-stat-value">{{ counts.unfulfilled }}</div>
      <div class="scv2-stat-label">Unfulfilled</div>
    </button>
    <button type="button" class="scv2-stat-card" [class.scv2-active]="filter === 'fulfilled'" (click)="setStatFilter('fulfilled')">
      <div class="scv2-stat-value">{{ counts.fulfilled }}</div>
      <div class="scv2-stat-label">Fulfilled</div>
    </button>
    <button type="button" class="scv2-stat-card" [class.scv2-active]="filter === 'delivered'" (click)="setStatFilter('delivered')">
      <div class="scv2-stat-value">{{ counts.delivered }}</div>
      <div class="scv2-stat-label">Delivered</div>
    </button>
  </div>

  <div class="scv2-chip-row scv2-no-print">
    <button type="button" *ngFor="let f of filterChips" class="scv2-chip" [class.scv2-active]="filter === f" (click)="filter = f">
      {{ chipLabel(f) }}
    </button>
  </div>

  <div class="scv2-table scv2-no-print">
    <div class="scv2-table-head">
      <div class="scv2-col-order">Order</div>
      <div class="scv2-col-carrier">Carrier / tracking</div>
      <div class="scv2-col-status">Status</div>
      <div class="scv2-col-action">Action</div>
    </div>
    <div class="scv2-table-row" *ngFor="let o of filtered">
      <div class="scv2-col-order">
        <div class="scv2-order-id">#{{ o.id }}</div>
        <div class="scv2-order-sub">{{ o.customer }} · {{ o.itemsSummary }}</div>
      </div>
      <div class="scv2-col-carrier">
        <ng-container *ngIf="o.carrierId; else noCarrier">
          <app-carrier-mark-v2 [carrierId]="o.carrierId" [size]="24"></app-carrier-mark-v2>
          <span class="scv2-tracking">{{ o.tracking }}</span>
        </ng-container>
        <ng-template #noCarrier><span class="scv2-muted">—</span></ng-template>
      </div>
      <div class="scv2-col-status">
        <span class="scv2-badge" [ngClass]="'scv2-badge-' + statusMeta(o.step).tone">{{ statusMeta(o.step).label }}</span>
      </div>
      <div class="scv2-col-action">
        <ng-container *ngIf="o.step === -1; else manageActions">
          <button type="button" class="scv2-btn-primary" [disabled]="!anyCarrier" (click)="open(o)"><i class="pi pi-box"></i> Create shipping label</button>
        </ng-container>
        <ng-template #manageActions>
          <button
            *ngIf="o.service && o.service !== 'Manual tracking'"
            type="button"
            class="scv2-icon-btn"
            title="Print label"
            aria-label="Print label"
            (click)="quickPrint(o)"
          >
            <i class="pi pi-print"></i>
          </button>
          <button type="button" class="scv2-btn-ghost" (click)="open(o)">
            <i class="pi" [ngClass]="o.step < 3 ? 'pi-pencil' : 'pi-check-circle'"></i>
            {{ o.step < 3 ? 'Manage' : 'View' }}
          </button>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- quick-print stage (only visible while printing) -->
  <div *ngIf="printingOrder" class="scv2-print-stage">
    <app-shipping-label-v2 [order]="printingOrder"></app-shipping-label-v2>
  </div>
</div>

<!-- create / manage label modal -->
<p-dialog
  *ngIf="openOrder as order"
  [visible]="true"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  (onHide)="close()"
  [style]="{ width: '560px', maxWidth: '94vw' }"
  styleClass="scv2-dialog"
>
  <ng-template pTemplate="header">
    <div class="scv2-dialog-head">
      <h3>{{ order.step >= 0 ? 'Order #' + order.id : 'Create shipping label' }}</h3>
      <p>{{ order.customer }} · {{ order.itemsSummary }}</p>
    </div>
  </ng-template>

  <div class="scv2-info-box scv2-gray-box scv2-no-print">
    <i class="pi pi-map-marker"></i>
    <p>{{ order.address }}</p>
  </div>

  <!-- NO label yet -->
  <ng-container *ngIf="order.step < 0">
    <div class="scv2-pkg">
      <div class="scv2-pkg-title">Package</div>
      <div class="scv2-pkg-grid">
        <input class="scv2-input" value="2.4" placeholder="Weight (lb)" />
        <input class="scv2-input" value="10" placeholder="Length (in)" />
        <input class="scv2-input" value="8" placeholder="Width (in)" />
        <input class="scv2-input" value="4" placeholder="Height (in)" />
      </div>
    </div>

    <div *ngIf="apiCarriers.length > 0" class="scv2-rates">
      <div class="scv2-pkg-title">Choose a shipping service</div>
      <div class="scv2-rate-list">
        <app-rate-option-v2
          *ngFor="let r of rateOptions"
          [id]="r.id"
          [carrier]="r.carrier"
          [service]="r.service"
          [eta]="r.eta"
          [price]="r.price"
          [suggested]="r.id === cheapestId"
          [selected]="selectedRate === r.id"
          (selectRate)="selectedRate = $event"
        ></app-rate-option-v2>
      </div>
      <button type="button" class="scv2-btn-primary" [disabled]="!selectedRate || buying" (click)="buyLabel()">
        <i class="pi" [ngClass]="buying ? 'pi-spinner pi-spin' : 'pi-print'"></i>
        {{ buying ? 'Buying label…' : (selectedRate ? 'Buy shipping label — $' + selectedRateOption().price.toFixed(2) : 'Buy shipping label') }}
      </button>
      <p class="scv2-fine">Billed to your LincSell account. The order is marked Fulfilled as soon as you buy.</p>
    </div>

    <div *ngIf="manualCarriers.length > 0" class="scv2-manual" [class.scv2-manual-bordered]="apiCarriers.length > 0">
      <div class="scv2-pkg-title">{{ apiCarriers.length > 0 ? 'Or add tracking manually' : 'Add tracking manually' }}</div>
      <div class="scv2-grid-2">
        <div class="scv2-field">
          <label>Carrier</label>
          <div class="scv2-select-wrap">
            <select class="scv2-select" [(ngModel)]="manualCarrier">
              <option *ngFor="let id of manualCarriers" [value]="id">{{ carriers[id].name }}</option>
            </select>
            <i class="pi pi-chevron-down"></i>
          </div>
        </div>
        <div class="scv2-field">
          <label>Tracking number</label>
          <input class="scv2-input" placeholder="Enter tracking #" [(ngModel)]="manualTracking" />
        </div>
      </div>
      <button type="button" class="scv2-btn-primary" (click)="fulfillManually()"><i class="pi pi-truck"></i> Fulfill order</button>
    </div>

    <div *ngIf="apiCarriers.length === 0 && manualCarriers.length === 0" class="scv2-info-box scv2-danger-box">
      <i class="pi pi-exclamation-circle"></i>
      <p>No carrier connected yet — connect one first to ship this order.</p>
    </div>
  </ng-container>

  <!-- HAS label -->
  <ng-container *ngIf="order.step >= 0">
    <div *ngIf="order.service !== 'Manual tracking'" class="scv2-label-preview">
      <app-shipping-label-v2 [order]="order"></app-shipping-label-v2>
    </div>

    <div class="scv2-label-actions scv2-no-print">
      <button *ngIf="order.service !== 'Manual tracking'" type="button" class="scv2-btn-primary" (click)="print()"><i class="pi pi-print"></i> Print label</button>
      <button *ngIf="order.step === 0" type="button" class="scv2-btn-ghost scv2-danger-btn" (click)="voidLabel()"><i class="pi pi-ban"></i> Void label</button>
    </div>
    <p *ngIf="order.service !== 'Manual tracking'" class="scv2-fine scv2-no-print">
      Tip: in the print dialog, choose "Save as PDF" to download instead of printing.
    </p>

    <div class="scv2-track-title scv2-no-print">Tracking status</div>
    <div class="scv2-track-stepper scv2-no-print">
      <app-status-stepper-v2 [stepIndex]="order.step"></app-status-stepper-v2>
    </div>
    <div class="scv2-track-foot scv2-no-print">
      <p>Normally updates automatically from carrier tracking — advance manually here to preview.</p>
      <button type="button" class="scv2-btn-primary" [disabled]="order.step >= steps.length - 1" (click)="advance()">
        {{ order.step >= steps.length - 1 ? 'Delivered' : 'Mark as "' + steps[order.step + 1] + '"' }}
      </button>
    </div>
  </ng-container>
</p-dialog>
